var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTableContext } from './internal/TableContext';

import { default as withStyles } from '../styles';
import { default as MuiTableBody } from '@material-ui/core/TableBody';
import isEqual from 'lodash/isEqual';

var styles = {
    root: {}
};

/**
 * The body of the table
 */
var TableBody = React.forwardRef(function (props, ref) {
    var classes = props.classes,
        children = props.children,
        rest = _objectWithoutProperties(props, ['classes', 'children']);

    var _useState = useState([]),
        _useState2 = _slicedToArray(_useState, 2),
        rowData = _useState2[0],
        setRowData = _useState2[1];

    var classOverrides = {
        root: classes.root
    };

    var _useTableContext = useTableContext(),
        rowSelectionEnabled = _useTableContext.rowSelectionEnabled,
        registerRowData = _useTableContext.registerRowData;

    var localChildren = children;

    // keeps track of all the row data
    var localRowData = [];

    if (rowSelectionEnabled) {

        // this loop does two things:
        //
        //   1. decorates all child rows, to let them know they're children
        //      of a table body
        //   2. stores data associated with each table
        localChildren = React.Children.map(children, function (child) {
            if (child.type.muiName === 'TableRow' || child.type.muiName === 'TableExpandableRow') {

                // SIDE EFFECT: store row data
                localRowData.push(child.props.rowData);

                // tell the row that it belongs to the table body
                return React.cloneElement(child, { parentRowGroup: 'tablebody' });
            } else {
                return child;
            }
        });
    }

    // updates the row data state (if it's changed since last time the table
    // body was rendered)
    useEffect(function () {
        if (rowSelectionEnabled) {
            if (!isEqual(rowData, localRowData)) {
                setRowData(localRowData);
            };
        }
    }, [rowSelectionEnabled, localRowData, rowData]);

    // transmit all row data to parent table (if the data has changed); note that
    // this fires only if we determine (above) that the row data has changed
    useEffect(function () {
        if (rowSelectionEnabled) {
            registerRowData(rowData);
        }
    }, [rowData, registerRowData, rowSelectionEnabled]);

    return React.createElement(
        MuiTableBody,
        Object.assign({}, rest, {
            classes: classOverrides,
            ref: ref
        }),
        localChildren
    );
});

TableBody.muiName = 'TableBody';
TableBody.displayName = 'TableBody';

TableBody.propTypes = {
    /**
     * The content of the component, normally `TableRow`.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * The component used for the root node. Either a string to use a DOM element or a component.
     */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])

};

// default props
TableBody.defaultProps = {
    component: 'tbody'
};

export default withStyles(styles)(TableBody);